export default {
    apiUrl: (window as any).globalConfig.adminToolApi
};

export const throwErrors = (response: Response) => {
    if (!response.ok) {
        throw response;
    }
    return response;
}